import React, { useContext } from 'react';
import NotificationBanner from '@repo/ui-components/notification-banner';
import { MavenoidChatButton } from '@repo/ui-components/openChatWidget';
import { Header } from '@repo/ui-components/header';
import { SiteSettingsContext } from '@repo/contexts/SiteSettingsContext';
import { useSportdogInternationalContext } from '@util/static-translations';
import { showMavenoid } from '@util/page-helpers/showMavenoid';
import getInternalLink from '@components/utils/getInternalLink';

function LayoutHeader() {
  const { siteSettings, algoliaSearchSettings } =
    useContext(SiteSettingsContext);
  const { notificationBanner, mainMenu } = siteSettings;
  const { locale } = useSportdogInternationalContext();

  const { productIndexName, blogIndexName } = algoliaSearchSettings;

  const SportdogMavenoidChatButton = showMavenoid(locale)
    ? MavenoidChatButton
    : null;

  return (
    <>
      <NotificationBanner
        messageText={notificationBanner?.text}
        messageLink={notificationBanner?.link?.href}
        messageType={notificationBanner?.link?.linkType}
        messageSvg={notificationBanner?.blockSvg}
        ChatComponent={SportdogMavenoidChatButton}
      />
      <Header
        menuStructure={mainMenu}
        searchIndexes={[productIndexName, blogIndexName]}
        getInternalLink={getInternalLink}
        brandName="SportDOG"
      />
    </>
  );
}

export default LayoutHeader;
